import AutocompleteField from "../../../Form/AutocompleteField";
import { LANGUAGES_LINKEDIN_OPTIONS } from "../../../../utils/catalogs/languageOptions";

const SelectLanguagesLinkedinForm = ({
  name,
  control,
  errors,
  sx = {},
  disabled = false,
}) => {
  return (
    <AutocompleteField
      name={name}
      control={control}
      errors={errors}
      options={LANGUAGES_LINKEDIN_OPTIONS}
      doTranslate={true}
      fullWidth
      multiple={false}
      sx={sx}
      disabled={disabled}
    />
  );
};

export default SelectLanguagesLinkedinForm;
